import { render, staticRenderFns } from "./MUserSelector.vue?vue&type=template&id=58a939b4&scoped=true&lang=pug&"
import script from "./MUserSelector.vue?vue&type=script&lang=js&"
export * from "./MUserSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a939b4",
  null
  
)

export default component.exports